// extracted by mini-css-extract-plugin
export var compactFilters = "_el-4";
export var detailImage = "_el-1";
export var dropdownContainer = "_el-2";
export var imageContainer = "_el-0";
export var selectedCard = "_el-3";